import { CheckCircleOutlined } from '@ant-design/icons';
import { Row } from '@vertem-core/vertice-ds';
import { Col } from '@vertem-core/vertice-ds';
import {
  Result,
  VertButton,
  VertContainer,
  VertTypography,
} from '@vertem-core/vertice-ds';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NewSolicitationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    if (!state) {
      navigate('/list-redemptions');
    }
  }, []);

  return (
    <VertContainer fluid>
      <VertContainer spacingX="regular" spacingY="small">
        <Result
          className="result-success-spot"
          status="success"
          icon={<CheckCircleOutlined className="icon-check" />}
        >
          <Row
            gutter={[16, 16]}
            className="result-success-spot__content"
            justify="center"
          >
            <Col span={24} xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
              <VertTypography.Title className="title-sucess-spot">
                {`Sua solicitação foi enviada com sucesso. ID #${state?.id}`}
              </VertTypography.Title>

              <div className="box_content-sucess-spot">
                <VertTypography.Paragraph
                  className="result-success-spot__description"
                  type="default"
                >
                  Sua solicitação foi enviada para nossa central de controle e
                  em breve você terá uma resposta.
                </VertTypography.Paragraph>
                <VertTypography.Paragraph
                  className="result-success-spot__description"
                  type="default"
                >
                  Ah, fique tranquilo, te avisaremos via e-mail assim que ela
                  for aprovada.
                </VertTypography.Paragraph>
              </div>
              <div className="result-success-spot__button">
                <VertButton
                  type="default"
                  onClick={() => {
                    navigate('/list-redemptions');
                  }}
                >
                  Ver Solicitações
                </VertButton>
              </div>
            </Col>
          </Row>
        </Result>
      </VertContainer>
    </VertContainer>
  );
};

export default NewSolicitationSuccess;
